const KEY = "cz_ref_code";
const TTL_MS = 30 * 24 * 60 * 60 * 1000;

function hasActiveSession(): boolean {
  if (typeof window === "undefined") return false;
  try {
    for (let i = 0; i < window.localStorage.length; i++) {
      const k = window.localStorage.key(i) ?? "";
      if (k.startsWith("sb-") && k.endsWith("-auth-token")) {
        const v = window.localStorage.getItem(k);
        if (v && v.length > 2) return true;
      }
    }
  } catch { /* ignore */ }
  return false;
}

export function captureReferralFromUrl() {
  if (typeof window === "undefined") return;
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (!ref || !/^[A-Za-z0-9]{4,32}$/.test(ref)) return;

    // Never attach a referral to an already-authenticated user — referrals are
    // first-touch attribution for *new* sign-ups only.
    if (hasActiveSession()) return;

    // First-touch wins: do NOT overwrite an existing stored code on later visits.
    const existing = window.localStorage.getItem(KEY);
    if (existing) {
      try {
        const { ts } = JSON.parse(existing) as { code: string; ts: number };
        if (Date.now() - ts <= TTL_MS) return; // keep first-touch
      } catch { /* fall through and replace corrupted entry */ }
    }

    window.localStorage.setItem(KEY, JSON.stringify({ code: ref.toUpperCase(), ts: Date.now() }));
  } catch {
    /* ignore */
  }
}

/**
 * Uloží referral kód z osobního odkazu (/r/<KOD>). First-touch: existující
 * platný kód se nepřepisuje a přihlášenému uživateli se nic neukládá.
 */
export function storeReferralCode(code: string) {
  if (typeof window === "undefined") return;
  if (!/^[A-Za-z0-9]{4,32}$/.test(code)) return;
  if (hasActiveSession()) return;
  try {
    const existing = window.localStorage.getItem(KEY);
    if (existing) {
      try {
        const { ts } = JSON.parse(existing) as { code: string; ts: number };
        if (Date.now() - ts <= TTL_MS) return;
      } catch { /* přepíšeme poškozený záznam */ }
    }
    window.localStorage.setItem(KEY, JSON.stringify({ code: code.toUpperCase(), ts: Date.now() }));
  } catch { /* ignore */ }
}

export function getStoredReferralCode(): string | null {

  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const { code, ts } = JSON.parse(raw) as { code: string; ts: number };
    if (Date.now() - ts > TTL_MS) {
      localStorage.removeItem(KEY);
      return null;
    }
    return code || null;
  } catch {
    return null;
  }
}

export function clearStoredReferralCode() {
  if (typeof window === "undefined") return;
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
